import React from 'react';
import './LegalModal.css';

const LegalModal = ({ isOpen, onClose, title, content }) => {
  if (!isOpen) return null;

  return (
    <div className="legal-modal-overlay" onClick={onClose}>
      <div className="legal-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="legal-modal-header">
          <h2 className="legal-modal-title">{title}</h2>
          <button className="legal-modal-close" onClick={onClose}>
            <i className="fi fi-rr-cross"></i>
          </button>
        </div>
        <div className="legal-modal-body">
          {content}
        </div>
        <div className="legal-modal-footer">
          <button className="btn btn-primary" onClick={onClose}>סגור</button>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;

